/*
 *
 * Package: `@dbh/hotel-package-field-theme`.
 *
 */const THEME_KEY_HOTEL_PACKAGE_FIELD="hotelPackageField";const modifyHotelPackageFieldTheme=a=>{let{spacing:{sp4:b,sp5:c},colors:{greyLight:d,white:e}}=a;return {[THEME_KEY_HOTEL_PACKAGE_FIELD]:{packageWrapper:{margin:"0 0 "+b,boxShadow:"0px 1px 6px "+d,backgroundColor:e},contentWrapper:{padding:b+" "+c+" 0",borderRadius:0,border:"1px solid "+d},title:{highlighted:{weight:"bold"},normal:{weight:"normal"}},toolbarWrapper:{padding:c+" 0",desktop:{padding:c+" 0"}},priceWrapper:{desktop:{padding:"0"}}}}};

export { THEME_KEY_HOTEL_PACKAGE_FIELD, modifyHotelPackageFieldTheme as default };
